module.exports = __webpack_public_path__ + "static/img/icon-history.3ed90e7c.png";